import styled, {css} from 'styled-components'
import {typography} from '../styles'

export default styled.ul`
  margin: 1rem;
  li {
    display: block;
    ${typography.lh14}
    margin: 1rem 0 0 1.5em;
    text-indent: -1em;
    &::before {
      content: '\\01F449';
      display: inline-block;
      width: 1rem;
    }
  }
  ${props => props.ticks && css`
    li::before {
      content: '\\02705';
    }
  `}
  strong {
    ${typography.bold}
  }
`



/** WEBPACK FOOTER **
 ** ./src/components/List.js
 **/